<template>
<div class="h-screen w-full" id="page-login">
    <div class="w-full sm:m-0 m-4">
        <vx-card>
            <div slot="no-body" class="full-page-bg-color">
                <div class="vx-row">
                    <div class="hidden h-screen lg:block lg:w-2/3 flex items-center">
                        <div class="h-full flex item-center">
                            <img src="@/assets/images/slider/meeting.svg" alt="login" class="m-auto">
                        </div>
                    </div>
                    <div class="w-full h-screen md:w-full lg:w-1/3 d-theme-dark-bg">

                        <div class="h-full flex item-center">
                            <div class="w-9/12 m-auto grid grid-rows-7 gap-4">
                                <div class="text-center">
                                    <div class="text-center flex justify-center mb-16 lg:mb-20 md:mb-20 sm:mb-6">
                                        <img src="@/assets/images/logo/car_icon.png" alt="login" class="md:w-1/5 lg:w-1/5 sm:w-2/5 w-1/5 text-center">
                                    </div>
                                    <h4 class="title font-bold text-3xl text-primary text-center">Bienvenidos</h4>
                                </div>
                                <div>
                                    <p>Por favor ingresa a tu cuenta</p>
                                </div>
                                <vs-input name="email" icon-no-border icon="icon icon-user" icon-pack="feather" label="Email" v-model="data.email" class="w-full" />

                                <vs-input type="password" name="password" icon-no-border icon="icon icon-lock" icon-pack="feather" label="Password" v-model="data.password" class="w-full" />
                                <div>
                                    <a class="mb-6 mt-2">Olvide mi contraseña</a>
                                </div>
                                <div>
                                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3 sm:mb-1">Recuerdame</vs-checkbox>
                                </div>
                                <div>
                                    <vs-button class="w-full font-bold" @click="auth">Ingresar</vs-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</div>
</template>

<script>
import login from '@/services/login';
export default {
    data() {
        return {
            data: {
                email: "",
                password: "",
            },
            checkbox_remember_me: false,
        };
    },
    methods: {
        async auth() {
            const response = await login(this.data)
            console.log(response)
            const path = ''
            try {
                localStorage._session_token = response.data.access_token
                this.$router.push('/home');
            } catch (error) {
                console.log(error)
            }

        },
    },
};
</script>

<style lang="scss">
.title {
    font-family: 'Montserrat';
    font-style: normal;
}

#page-login {
    .social-login-buttons {
        .bg-facebook {
            background-color: #1551b1
        }

        .bg-twitter {
            background-color: #00aaff
        }

        .bg-google {
            background-color: #4285F4
        }

        .bg-github {
            background-color: #333
        }
    }
}
</style>
